export const LOAD_MEMBERSHIPS = 'App/Membership::LOAD_MEMBERSHIPS';
export const CHOOSE_MEMBERSHIP = 'App/Membership::CHOOSE_MEMBERSHIP';
